<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.PARENT_CHILD_COMPANIES.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <div>{{ 'ASSOCIATIONS.PARENT_CHILD_COMPANIES.PARENT_SECTION_TITLE' | translate }}</div>
  <ng-container *ngIf="parentCompany$ | async as parent; else setParentButton">
    <crm-association-card
      [cardData]="parent"
      [showEditTagButton]="false"
      (removeClick)="removeParentAssociation(parent)"
    ></crm-association-card>
  </ng-container>
  <ng-template #setParentButton>
    <button mat-stroked-button color="primary" class="button-company-association-card" (click)="openSetParentModal()">
      <mat-icon>add</mat-icon>
      {{ 'ASSOCIATIONS.PARENT_CHILD_COMPANIES.SET_PARENT_COMPANY' | translate }}
    </button>
  </ng-template>
  <div>{{ 'ASSOCIATIONS.PARENT_CHILD_COMPANIES.CHILD_SECTION_TITLE' | translate }}</div>
  <ng-container *ngFor="let child of childCompanies$ | async">
    <crm-association-card
      *ngIf="child.businessName"
      [cardData]="child"
      [showEditTagButton]="false"
      (removeClick)="removeChildAssociation(child)"
    ></crm-association-card>
  </ng-container>
  <button mat-stroked-button color="primary" class="button-company-association-card" (click)="openAddChildModal()">
    <mat-icon>add</mat-icon>
    {{ 'ASSOCIATIONS.PARENT_CHILD_COMPANIES.ADD_CHILD_COMPANY' | translate }}
  </button>
</mat-expansion-panel>
